module.exports = __webpack_public_path__ + "static/media/c3bannerModul3_small.4850f08d.jpg";